import { IAgentConfigDisplay, AgentTypeEnum } from '@app/models';

export const getAgentDisplayFromType = (agentType: string): IAgentConfigDisplay => {
    let agentConfig: IAgentConfigDisplay = {} as IAgentConfigDisplay;

    switch (agentType) {
        case AgentTypeEnum.windowsLogon:
            agentConfig.PolicyId = true;
            agentConfig.SyncIntervalMinutes = true;
            agentConfig.RedirectURI = false;
            agentConfig.RequiresConsent = false;
            agentConfig.WLA2FATimeoutSeconds = true;
            break;
        case AgentTypeEnum.radiusServer:
            agentConfig.PolicyId = true;
            agentConfig.SyncIntervalMinutes = true;
            agentConfig.RedirectURI = false;
            agentConfig.RequiresConsent = false;
            agentConfig.WLA2FATimeoutSeconds = false;
            break;
        case AgentTypeEnum.oauth2Client:
            agentConfig.PolicyId = false;
            agentConfig.SyncIntervalMinutes = false;
            agentConfig.RedirectURI = false;
            agentConfig.RequiresConsent = false;
            break;
        case AgentTypeEnum.apiAuth:
        case AgentTypeEnum.webAuth:
            agentConfig.PolicyId = true;
            agentConfig.RedirectURI = true;
            agentConfig.RequiresConsent = true;
            agentConfig.SyncIntervalMinutes = false;
            break;
        case AgentTypeEnum.openidConnect:
            agentConfig.RedirectURI = true;
            agentConfig.RequiresConsent = true;
            agentConfig.PolicyId = false;
            agentConfig.SyncIntervalMinutes = false;
            break;
        default:
            agentConfig.PolicyId = true;
            agentConfig.SyncIntervalMinutes = true;
            agentConfig.RedirectURI = true;
            agentConfig.RequiresConsent = true;
    }

    return agentConfig;
};
